<div class="row justify-content-center">
  <div class="col text-center pt-4">
    <img
      [src]="themeService.image().presentationLogo"
      alt="Logo Excuela"
      width="230"
    />
  </div>
</div>
